import React from "react";
import { connect } from "react-redux";
import Axios from 'axios'
import { fetchEventsData } from "@/services/contentEvents/actions";
import Hero from "@/components/Hero";

import '@/components/EventsBanner/EventsBanner.scss';
import "./lists.scss";

class EventsList extends React.Component {
	state = {
		events: []
	};

	constructor(props) {
		super(props)
		this.fetchEventsList(this.props.data.datasource)
	}

	async fetchEventsList(listUrl) {
		Axios.get(listUrl)
			.then((response) => this.fetchEventsContent(response.data.contents))
			.then(res => {
				Promise.all(res)
					.then((vals) =>  vals)
					.then((lot) => this.setState({ events: lot }));
			});
	}

	async getEventContent(url) {
		return Axios.get(url);
	}

	async fetchEventsContent(listData) {
		console.log('listData: ', listData);
		let eventUrls = listData.map((item) => {
			for (let field of item.fields) {
				if (field.id === 'event') {
					return field.value;
				}
			}
		});

		let eventsContent = eventUrls.map(async (url) => {
			let contents = await this.getEventContent(url);
			return contents;
		});

		return eventsContent;
	}

	render() {
		console.log('IN RENDER evts: ', this.state.events);
		console.log('IN RENDER props: ', this.props);

		return (
			<div className="List">
				{this.state.events !== undefined && this.state.events.map((evt, ind) => {
					let img = {};
					let hdr = '';
					let desc = '';
					let ctaLbl = '';
					let ctaURL = '';

					for (const field of evt.data.contents[0].fields) {
						if (field.id === 'imageasset') {
							img = field;
							continue;
						}
						else if (field.id === 'headertitle') {
							hdr = field.value;
							continue;
						}
						else if (field.id === 'description') {
							desc = field.value;
							continue;
						}
						else if (field.id === 'ctalabel') {
							ctaLbl = field.value;
							continue;
						}
						else if (field.id === 'ctaurl') {
							ctaURL = field.value;
							continue;
						}
					}
					// const EventsBanner = (props) => {
					// const { headertitle, description, imageasset, ctalabel, ctaurl } = evt.data.contents[0].fields || {};
				
					return (
						<div key={img.imgURL} className='bannerContainer'>
							<Hero
								imageSource={img.imgURL}
								srcSet={`${img.imgURL} 750w, ${img.imgURL} 1984w`}
								alt={img.value}
								fullWidth={false}
							>
								<div className="hero-panel">
									<h2 role="heading" aria-level="1" className="hero-panel-title">
										{hdr}
									</h2>
									<p className="hero-panel-copy" dangerouslySetInnerHTML={{__html: desc}} target="_blank" rel="noreferrer" />
									{ctaLbl && <a target="_blank" rel="noreferrer" className='Header__book-cta cta' href={ctaURL} aria-label={ctaLbl}>{ctaLbl}</a>}
								</div>
							</Hero>
						</div>
					);
				})}
			</div>
		);
	}
}
const mapStateToProps = (state, ownProps) => {
	return {
		eventsData: state.pageContent.eventsData[ownProps.dataKey]
	};
};

export default connect(
	mapStateToProps,
	{ fetchEventsData }
)(EventsList);



// WEBPACK FOOTER //
// ./src/components/organisms/lists/EventsList.js